import { render, staticRenderFns } from "./MmrList.vue?vue&type=template&id=25ea61ea&scoped=true"
import script from "./MmrList.vue?vue&type=script&lang=js"
export * from "./MmrList.vue?vue&type=script&lang=js"
import style0 from "./MmrList.vue?vue&type=style&index=0&id=25ea61ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ea61ea",
  null
  
)

export default component.exports